import React from 'react';
import { ISVGType } from './SVGType';

const DarkSmartContractIcon = (props: ISVGType) => {
  const { height=43, width=42 } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 42 43" fill="none">
      <rect opacity="0.3" y="0.5" width="42" height="42" rx="10" fill="white" fillOpacity="0.4"/>
      {/*// @ts-ignore*/}
      <mask id="mask0_707_7859" style={{ 'mask-type':'alpha' }} maskUnits="userSpaceOnUse" x="11" y="11" width="20" height="21">
        <rect x="11" y="11.5" width="20" height="20" fill="url(#paint0_linear_707_7859)"/>
      </mask>
      <g mask="url(#mask0_707_7859)">
        <path d="M12.667 16.0002V11.8335H16.8337V13.5002H14.3337V16.0002H12.667ZM27.667 16.0002V13.5002H25.167V11.8335H29.3337V16.0002H27.667ZM12.667 30.1668V26.0002H14.3337V28.5002H16.8337V30.1668H12.667ZM25.167 30.1668V28.5002H27.667V26.0002H29.3337V30.1668H25.167ZM16.8337 26.0002H25.167V16.0002H16.8337V26.0002ZM16.8337 27.6668C16.3753 27.6668 15.983 27.5036 15.6566 27.1772C15.3302 26.8509 15.167 26.4585 15.167 26.0002V16.0002C15.167 15.5418 15.3302 15.1495 15.6566 14.8231C15.983 14.4967 16.3753 14.3335 16.8337 14.3335H25.167C25.6253 14.3335 26.0177 14.4967 26.3441 14.8231C26.6705 15.1495 26.8337 15.5418 26.8337 16.0002V26.0002C26.8337 26.4585 26.6705 26.8509 26.3441 27.1772C26.0177 27.5036 25.6253 27.6668 25.167 27.6668H16.8337ZM18.5003 19.3335H23.5003V17.6668H18.5003V19.3335ZM18.5003 21.8335H23.5003V20.1668H18.5003V21.8335ZM18.5003 24.3335H23.5003V22.6668H18.5003V24.3335Z" fill="url(#paint1_linear_707_7859)"/>
      </g>
      <defs>
        <linearGradient id="paint0_linear_707_7859" x1="21" y1="11.5" x2="21" y2="31.5" gradientUnits="userSpaceOnUse">
          <stop stopColor="#EF5F14"/>
          <stop offset="1" stopColor="#E88947"/>
        </linearGradient>
        <linearGradient id="paint1_linear_707_7859" x1="21.0003" y1="11.8335" x2="21.0003" y2="30.1668" gradientUnits="userSpaceOnUse">
          <stop stopColor="#EF5F14"/>
          <stop offset="1" stopColor="#E88947"/>
        </linearGradient>
      </defs>
    </svg>
  );
};

export default DarkSmartContractIcon;
